import { AxiosError } from "axios";

export const extractApiErrorMessage = (
  error: unknown,
  fallbackMessage: string,
): string => {
  if (error instanceof AxiosError) {
    const message = error.response?.data?.message;
    if (typeof message === "string" && message.trim()) {
      return message;
    }
  }
  return fallbackMessage;
};
